<template>
  <!-- A page whose root carries `page-fill` takes the window's height, so only its own scroll area moves. -->
  <div
    :class="containerClass"
    class="has-[>.page-fill]:flex has-[>.page-fill]:min-h-0 has-[>.page-fill]:flex-1 has-[>.page-fill]:flex-col"
  >
    <slot />
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

import { providePageWidth } from '@/composables/use-page-width/usePageWidth'

const isConstrained = providePageWidth()

const containerClass = computed(() => (isConstrained.value ? 'w-full max-w-[1440px] mx-auto' : 'w-full'))
</script>
